import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";

// Gallery
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";

const GalleryContainer = styled.div`
  position: relative;

  width: 100%;
  // height: 100%;

  /* margin: 0 0 2em 0; */
  margin: 2em 0;

  padding: 0 20px;

  overflow: hidden;

  & img {
    width: 100%;
    height: 100%;

    &.image-landscape {
      object-fit: cover;
    }

    &.image-portrait {
      object-fit: contain;
    }
  }

  /* & .caption {
    display: none;
  } */

  & .caption {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;

    padding: 15px 0 0 0;

    /* &.project-padded {
        padding: 15px 15px 0 15px;
      } */

    & p {
      margin: 0;
      font-size: 20px;
      line-height: 125%;
      font-feature-settings: "tnum";
    }
  }

  @media (max-width: 999px) {
    margin: 0 0 20px 0;
  }
`;

const Arrow = styled.button`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 50%;

  overflow: hidden;

  z-index: 100;

  cursor: none;

  &.previous {
    left: 0;

    cursor: url(/icons/arrow-prev-blue@1x.png) 9 9, pointer !important;
    cursor: -webkit-image-set(
          url(/icons/arrow-prev-blue@1x.png) 1x,
          url(/icons/arrow-prev-blue@2x.png) 2x
        )
        9 9,
      pointer !important;
  }

  &.next {
    right: 0;

    cursor: url(/icons/arrow-next-blue@1x.png) 9 9, pointer !important;
    cursor: -webkit-image-set(
          url(/icons/arrow-next-blue@1x.png) 1x,
          url(/icons/arrow-next-blue@2x.png) 2x
        )
        9 9,
      pointer !important;
  }

  & .counter {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;

    position: absolute;
    width: 100px;

    margin: 0;

    font-size: 24px;
    line-height: 30px;

    & .arrow {
      color: blue;
      font-size: 34px;

      margin: 0 10px;
    }
  }

  /* @media (hover: none) and (pointer: coarse) {
    display: none;
  } */
`;

export const Gallery = ({ color, galleryContent, type }) => {
  // Slideshow Reference
  const slideRef = useRef();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [totalSlides, setTotalSlides] = useState(galleryContent.length);

  // Update total slides when gallery content changes
  useEffect(() => {
    setTotalSlides(galleryContent.length);
  }, [galleryContent.length]);

  const updateCurrentSlide = (index) => {
    if (currentSlide !== index) {
      setCurrentSlide(index);
    }
  };

  // Preserve slide state during re-renders
  const [initialSlide, setInitialSlide] = useState(0);
  useEffect(() => {
    if (slideRef.current) {
      setInitialSlide(currentSlide);
    }
  }, [currentSlide]);

  return (
    <GalleryContainer>
      {galleryContent.length > 1 ? (
        <>
          <Arrow
            color={color}
            aria-label="Previous Slide"
            className={`previous`}
            onClick={() => {
              slideRef.current.goBack();
            }}
          ></Arrow>
          <Slide
            ref={slideRef}
            arrows={false}
            transitionDuration={0}
            pauseOnHover={false}
            autoplay={false}
            infinite={true}
            canSwipe={galleryContent.length > 1 ? true : false}
            defaultIndex={initialSlide}
            onChange={(previous, next) => updateCurrentSlide(next)}
          >
            {galleryContent}
          </Slide>
          <Arrow
            color={color}
            aria-label="Next Slide"
            className={`next`}
            onClick={() => {
              slideRef.current.goNext();
            }}
          ></Arrow>

          <div
            className={`caption ${type === `project` ? `project-padded` : ``}`}
          >
            <p>
              {currentSlide + 1}/{totalSlides}
            </p>
          </div>
        </>
      ) : (
        <>{galleryContent}</>
      )}
    </GalleryContainer>
  );
};
